import { InjectionToken } from '@angular/core';
import { TODO } from '@b2b/types/core/utils';

/**
 * Bridge to AngularJS `$q`.
 *
 * Used by `UtilsService.debounce` to hand a digest-integrated promise back to
 * AngularJS consumers. When all consumers have migrated to Angular 18, this
 * port can be replaced by native `Promise`.
 */
export interface IQDeferred<T = unknown> {
  resolve(value?: T | PromiseLike<T>): void;
  reject(reason?: unknown): void;
  promise: Promise<T>;
}

export interface IQPort {
  defer<T = unknown>(): IQDeferred<T>;
  all(promises: TODO[]): Promise<TODO[]>;
}

export const Q_PORT = new InjectionToken<IQPort>('Q_PORT');
